export default __webpack_public_path__ + "static/media/icon_fastag.f0169ba8.svg";